import * as React from 'react';
import { useState, useRef } from 'react';
import { Swiper, SwiperSlide, useSwiper, useSwiperSlide } from 'swiper/react';
import { className } from '@empori/util';
export default function TestimonialContent(props) {
    var testimonials = props.testimonials;
    var _a = useState(0), activeIndex = _a[0], updateIndex = _a[1];
    var parentRowDiv = useRef(null);
    if (!testimonials) {
        return null;
    }
    var configuredTestimonials = testimonials.filter(function (item) { return item.image && item.quote; });
    var breakpoints = {
        0: {
            spaceBetween: 20
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Swiper, { spaceBetween: 0, onSlideChange: function (swiper) { return updateIndex(swiper.realIndex); }, breakpoints: breakpoints, loop: configuredTestimonials.length > 1 ? true : false, autoHeight: true },
            React.createElement(PrevArrow, { activeIndex: activeIndex, totalSlides: configuredTestimonials.length }),
            configuredTestimonials.map(function (item, index) { return (React.createElement(SwiperSlide, { key: "slide-no-".concat(index + 1) },
                React.createElement(Slide, { singleTestimonial: item }))); }),
            React.createElement(NextArrow, { activeIndex: activeIndex, totalSlides: configuredTestimonials.length }))));
}
function PrevArrow(props) {
    var swiper = useSwiper();
    if (props.totalSlides > 1) {
        return (React.createElement("div", { className: 'swiper-arrow swiper-prev' },
            React.createElement("div", { className: 'arrow', onClick: function () { return swiper.slidePrev(); } },
                React.createElement("i", { className: 'fa-solid fa-angle-left empori-icon' })),
            React.createElement("div", { className: 'circle' })));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
function NextArrow(props) {
    var swiper = useSwiper();
    if (props.totalSlides > 1) {
        return (React.createElement("div", { className: 'swiper-arrow swiper-next' },
            React.createElement("div", { className: 'arrow', onClick: function () { return swiper.slideNext(); } },
                React.createElement("i", { className: 'fa-solid fa-angle-right empori-icon' })),
            React.createElement("div", { className: 'circle' })));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
function Slide(props) {
    var testimonial = props.singleTestimonial;
    var slide = useSwiperSlide();
    if (!testimonial) {
        return null;
    }
    return (React.createElement("div", { className: className('testimonial-content', { active: slide.isActive }) },
        React.createElement("div", { className: 'row' }, testimonial.isImageOnTheLeft ? (React.createElement(React.Fragment, null,
            React.createElement(Image, { singleTestimonial: testimonial }),
            React.createElement(Content, { singleTestimonial: testimonial }))) : (React.createElement(React.Fragment, null,
            React.createElement(Content, { singleTestimonial: testimonial }),
            React.createElement(Image, { singleTestimonial: testimonial }))))));
}
var Image = function (props) {
    return (React.createElement("div", { className: className('column column-3 image-wrapper', {
            // eslint-disable-next-line camelcase
            align_right: !props.singleTestimonial.isImageOnTheLeft
        }) },
        React.createElement("img", { height: '180', width: '180', className: 'image-logo', src: props.singleTestimonial.image, alt: 'testimonial', loading: 'lazy' })));
};
var Content = function (props) {
    return (React.createElement("div", { className: 'column column-9 text-content' },
        React.createElement("p", { className: 'quote' },
            React.createElement("q", null, props.singleTestimonial.quote)),
        React.createElement("p", { className: 'person' }, props.singleTestimonial.nameOfThePerson),
        React.createElement("p", { className: 'designation' }, props.singleTestimonial.designation)));
};
